<template>
  <div>
    <div class="select-button-container modal-body">
      <div class="button-group">
        <button
          type="button"
          class="btn btn-outline-primary type-button"
          @click="onClickNext('vod')">
          อัปโหลดไปยัง ThaiPBS VOD
        </button>
        <button
          type="button"
          class="btn btn-outline-primary type-button"
          @click="onClickNext('vod-multiple')" v-if="!isEdit">
          อัปโหลดไปยัง ThaiPBS VOD เลือกพร้อมกันหลายไฟล์
        </button>
        <button
          type="button"
          class="btn btn-outline-primary type-button"
          @click="onClickNext('select-vod')">
          เลือกจาก ThaiPBS VOD
        </button>
        <button
          type="button"
          class="btn btn-outline-primary type-button" @click="onClickNext('youtube')">
          เลือกจาก Youtube
        </button>
      </div>
    </div>
    <div class="modal-footer">
      <button
        v-if="isEdit"
        class="btn btn-outline-danger mr-auto"
        type="button"
        @click="onDeleteVideo">
        ลบ
      </button>
      <button
        type="button"
        class="btn btn-outline-secondary"
        @click="onClose">
        ยกเลิก
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['onClickNext', 'onClose', 'isEdit', 'onDeleteVideo'],
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.button-group {
  margin-bottom: $spacer;
  .type-button {
    width: 100%;
    margin-bottom: 0.75 * $spacer;
  }
  .type-button:last-child {
    margin-bottom: 0;
  }
}
</style>
